module.exports = __webpack_public_path__ + "media/images/featured_on/healthypaws.png";